import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { DEFAULT_IP } from "app/utils/constant";
import { cmnAssignFromBase, cmnSetValByPath } from "app/utils/utils";

export const initialCampaignEditCategory = {
    "campaign_type_id": "",
    "campaign_type_code": "",
    "campaign_type_name": {
        "en": "",
        "zh": ""
    }
}

export const initialCampaignEditVenue = {
    "venue_id": "",
    "venue_name": {
        "en": "",
        "zh": ""
    },
    "in_centre": "Y"
}

const initialState = {
    navItems: [],
    pagePermissions: {},
    audienceIdMap: {},
    memberIdentOptions: [],
    cmpgnAuditOptions: [],
    pushAuditOptions: [],
    adminList: [],
    roleList: [],
    campaignTypeList: [],
    editCmpgnCat: initialCampaignEditCategory,
    editCmpgnVenue: initialCampaignEditVenue,
    scrolToBottomTS: 0
};

export const getAudienceList = () => async (dispatch) => {
    await dispatch(getAudienceListReq());
};

export const getAdminList = () => async (dispatch) => {
    await dispatch(getAdminListReq());
};

export const getRoleList = () => async (dispatch) => {
    await dispatch(getRoleListReq());
};

export const getCampaignTypeList = () => async (dispatch) => {
    await dispatch(getCampaignTypeListReq());
};

export const createCampaignType = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(createCampaignTypeReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateCampaignType = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateCampaignTypeReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const createVenue = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(createVenueReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

export const updateVenue = (sendData, callback) => async (dispatch) => {
    const thunkResult = await dispatch(updateVenueReq(sendData));
    commonHandleError(thunkResult.payload, callback);
};

const getAudienceListReq = createAsyncThunk("mMainReq/tknAware/getAudienceList", async () => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/gettargetaudiencelist");
    return res.data;
});

const getAdminListReq = createAsyncThunk("mMainReq/tknAware/getAdminList", async () => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getadminlist");
    return res.data;
});

const getRoleListReq = createAsyncThunk("mMainReq/tknAware/getRoleList", async () => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getrolelist");
    return res.data;
});

const getCampaignTypeListReq = createAsyncThunk("mMainReq/tknAware/getCampaignTypeList", async () => {
    let res = await axios.get(DEFAULT_IP + "/webapp/memportal/getcampaigntypelist");
    return res.data;
});

const createCampaignTypeReq = createAsyncThunk("mMainReq/tknAware/createCampaignType", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/addcampaigntype", data);
    return res.data;
});

const updateCampaignTypeReq = createAsyncThunk("mMainReq/tknAware/updateCampaignType", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatecampaigntype", data);
    return res.data;
});

const createVenueReq = createAsyncThunk("mMainReq/tknAware/createVenue", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/addvenue", data);
    return res.data;
});

const updateVenueReq = createAsyncThunk("mMainReq/tknAware/updateVenue", async (data) => {
    let res = await axios.post(DEFAULT_IP + "/webapp/memportal/updatevenue", data);
    return res.data;
});

const commonHandleError = (data, callback) => {
    if (callback) {
        let baseErrorMsgObj = {
            message: "系統發生問題, 請稍後再試",
            message_en: "An unexpected error occurred. Please try again."
        }

        if (1 == data?.code) {
            callback(true, data);
        } else {
            callback(false, (data) ? (data) : (baseErrorMsgObj))
        }
    }
};

const rdxMainSlice = createSlice({
    initialState,
    name: "rdxMain",
    extraReducers: (builder) => {
        builder
            .addCase(getAudienceListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    let origAudData = data.data;

                    let idMapResult = {};
                    let cmpgnOptResult = [];
                    let mbrOptResult = [{ "audience_id": "", "audience_name": { "zh:": "", "en": "" } }];
                    let pushOptResult = [];


                    let memberMatches = ["adult", "presenior", "senior"];
                    let pushMatches = ["adult", "caregiver", "instructor", "presenior", "senior", "volunteer"];
                    origAudData.forEach((item) => {
                        idMapResult[item.audience_id] = item;
                        cmpgnOptResult.push(item);

                        if (memberMatches.includes(item.audience_id)) {
                            mbrOptResult.push(item);
                        }

                        if (pushMatches.includes(item.audience_id)) {
                            pushOptResult.push(item);
                        }
                    });

                    state.audienceIdMap = idMapResult;
                    state.cmpgnAuditOptions = cmpgnOptResult;
                    state.memberIdentOptions = mbrOptResult;
                    state.pushAuditOptions = pushOptResult;
                }
            })
            .addCase(getAdminListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    state.adminList = data.data;
                }
            })
            .addCase(getRoleListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    state.roleList = data.data;
                }
            })
            .addCase(getCampaignTypeListReq.fulfilled, (state, actions) => {
                let data = actions.payload;
                if (data.code === 1) {
                    let campaignTypeList = data.data;
                    campaignTypeList.sort((a, b) => {
                        if (a.campaign_type_code === null) return -1;
                        if (b.campaign_type_code === null) return 1;
                        return a.campaign_type_code?.localeCompare(b.campaign_type_code);
                    });
                    state.campaignTypeList = campaignTypeList;
                }
            });
    },
    reducers: {
        updateNavViewData(state, actions) {
            state.navItems = actions.payload;
        },
        setPagePermissions(state, actions) {
            let permissions = actions.payload;

            let result = {};
            permissions.forEach((item) => {
                let arr = item.split("_");
                let cat = arr[0];
                let func = arr[1];

                if (!result[cat]) {
                    result[cat] = {};
                }

                if ("campaign_review" == item) {
                    result["campaign"]["campaign_review"] = true;
                } else if (func) {
                    switch (func) {
                        case "u":
                            result[cat]["add"] = true;
                            result[cat]["edit"] = true;
                            break;
                        case "d":
                            result[cat]["delete"] = true;
                            break;
                    }
                }
            });

            state.pagePermissions = result;
        },
        initMainSimpleData(state, actions) {
            let { data, projection, type } = actions.payload;

            if ("list" == type) {
                let resultData = (data) ? data : [];
                state[projection] = resultData;
            } else if ("obj" == type) {
                let base = {};
                switch (projection) {
                    case "editCmpgnCat": base = initialCampaignEditCategory; break;
                    case "editCmpgnVenue": base = initialCampaignEditVenue; break;
                }

                let obj = cmnAssignFromBase(base, data);
                state[projection] = obj;
            }
        },
        setMainSimpleData(state, actions) {
            let { data, projection, path } = actions.payload;

            if (Array.isArray(data) && !path) {
                state[projection] = data;
            } else {
                let formatPath;
                if (path.indexOf(projection) == 0) {
                    let headStr = projection + ".";
                    formatPath = path.substring(headStr.length);
                } else {
                    formatPath = path;
                }
                cmnSetValByPath(state[projection], formatPath, data);
            }
        },
        updateScrollToBottom(state, actions) {
            state.scrolToBottomTS = new Date().getTime();
        }
    }
});

export const { updateNavViewData, setPagePermissions, initMainSimpleData, setMainSimpleData, updateScrollToBottom } = rdxMainSlice.actions;

export const rdxMainReducer = rdxMainSlice.reducer;